import { useAuth } from '../../app/auth/AuthContext';
import Button from '../../components/common/Button/Button';
import styles from './index.module.css';
import { Link, useLocation } from 'react-router-dom';

export const Topnav = () => {
  const { isAuthenticated, logout } = useAuth();
  const { pathname } = useLocation();

  return (
    <nav className={styles.topnav}>
      <div className={styles.section}>
        <h1 className={styles.title}>Codey</h1>
      </div>
      <div className={styles.spacer}></div>

      <div className={styles.section}>
        {isAuthenticated ? (
          <Button className={styles.action} onClick={logout}>
            Uitloggen
          </Button>
        ) : (
          <Link to={`/login?returnPath=${encodeURIComponent(pathname)}`}>
            <Button className={styles.action}>Inloggen</Button>
          </Link>
        )}
      </div>
    </nav>
  );
};
